import { createWebSocketStore } from 'src/components/#services/helpers';
export const getSettingOption = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'admin',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'option_get',
    },
});
